export default __webpack_public_path__ + "064db81ca0ea310731f96e53580dcc99.svg";